"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _theme = require("../../../theme");
var _default = (0, _theme.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    iconActionButton: function iconActionButton(_ref2) {
      var color = _ref2.color;
      var themeColor = color in palette ? palette[color].main : palette.primary.main;
      return {
        padding: 8,
        minWidth: 'inherit',
        width: 42,
        height: 42,
        boxShadow: 'none',
        backgroundColor: '#F0F0F0',
        fontSize: '16px',
        color: '#7B7B7B',
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: (0, _core.fade)(themeColor, 0.2),
          color: themeColor
        }
      };
    }
  };
}, {
  name: 'IconActionButton'
});
exports["default"] = _default;